import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { buildDesign } from "../lib/inviteDesigns";
import { LanguagePicker } from "../components/LanguagePicker";
import { InviteStage } from "../components/invites/InviteStage";
import { fileUrl } from "../components/site/HeroSlides";

export default function PublicInvitePage() {
  const { slug, inviteId } = useParams();
  const [sp] = useSearchParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    const g = sp.get("g");
    const k = `lif_inv_${inviteId}_${g || ""}`;
    const count = !sessionStorage.getItem(k) && !sp.get("preview");
    sessionStorage.setItem(k, "1");
    api.get(`/public/invites/${slug}/${inviteId}?count=${count}${g ? `&g=${encodeURIComponent(g)}` : ""}`).then((r) => setD(r.data)).catch((e) => setErr(formatApiError(e)));
  }, [slug, inviteId, sp]);
  if (err) return <div className="min-h-screen flex items-center justify-center text-[var(--muted)] p-6 text-center" data-testid="invite-error">{err}</div>;
  if (!d) return <div className="min-h-screen bg-black" />;
  const g = sp.get("g");
  const track = (event, scene, total) => { if (g && !sp.get("preview")) api.post(`/public/invites/${slug}/${inviteId}/progress`, { g, event, scene, total }).catch(() => {}); };
  return (
    <div className="min-h-[100dvh] bg-black flex items-center justify-center" data-testid="public-invite">
      <LanguagePicker className="fixed bottom-4 left-3" up />
      <InviteStage design={buildDesign(d.invite)} narrationUrl={d.invite.narration_path ? fileUrl(d.invite.narration_path) : null} inv={d.invite} wedding={d.wedding} guest={d.guest?.name} guestId={d.guest?.guest_id} track={track}
        musicUrl={d.invite.music_path ? fileUrl(d.invite.music_path) : null} className="w-full max-w-[480px] h-[100dvh] sm:h-[860px] sm:max-h-[100dvh] sm:rounded-3xl" />
    </div>
  );
}
